import { MAX_FILE_SIZE } from '@utils/constants/value';
import { Regex } from '../constants/index';
import { allowImgExt } from '@utils/constants/enums';
import { store } from '@redux/store';
import { showError } from '@redux/actions';

export const isEmpty = (value: string) => {
  if (!value) {
    return true;
  }

  return false;
};

export const isEmail = (value: string) => {
  if (Regex.RULE.EMAIL.test(value)) {
    return true;
  }

  return false;
};

export const isNumber = (value: string) => {
  if (Regex.RULE.NUMBER.test(value)) {
    return true;
  }

  return false;
};

/**
 * Check valid password
 */
export const isPassword = (value: string) => {
  return (
    value &&
    /(?=(.*[0-9]))(?=.*[!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,30}/g.test(
      value
    )
  );
};

/**
 * Check valid Image
 */
export const validateFileImage = (file: File) => {
  if (file) {
    const fileExtension = file.name.split('.').pop()?.toLowerCase() ?? '';
    if (file.size > MAX_FILE_SIZE) {
      store.dispatch(showError({ message: 'MSE00003' }));
      return false;
    } else if (!allowImgExt.includes(fileExtension)) {
      store.dispatch(showError({ message: 'common.file_extension' }));
      return false;
    }
    return true;
  }
};

export const isDatetime = (value: string) => {
  return typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/);
};
